export function gradientTint(theme, tint) {
    if(!theme.palette.hasOwnProperty(tint)) {
        tint = 'default';
    }

    return {
        backgroundColor: theme.palette[tint][600],// theme.palette.background.level1,
        /*
        backgroundImage: tint && `linear-gradient(180deg, ${theme.palette[tint][100]} 0%, ${theme.palette[tint][50]} 40%);`,
        [theme.getColorSchemeSelector('dark')]: {
            // backgroundImage: tint && `linear-gradient(180deg, ${theme.palette[tint][50]} 0%, transparent 100%);`,// : null,
            backgroundImage: tint && `linear-gradient(180deg, ${theme.palette[tint][50]}6B 0%, ${theme.palette[tint][100]}6B 100%);`,
        },
        */
    }
}
